import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=49b990f8&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"
import style0 from "./Code.vue?vue&type=style&index=0&id=49b990f8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b990f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b990f8')) {
      api.createRecord('49b990f8', component.options)
    } else {
      api.reload('49b990f8', component.options)
    }
    module.hot.accept("./Code.vue?vue&type=template&id=49b990f8&scoped=true", function () {
      api.rerender('49b990f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/Code.vue"
export default component.exports